'use strict';

exports.__esModule = true;
exports.default = WrongRuleDefinition;
function WrongRuleDefinition(message) {
  this.name = 'WrongRuleDefinition';
  this.message = message;
}

WrongRuleDefinition.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/errors/WrongRuleDefinition.js
// module id = 2MM7
// module chunks = 0